module.exports = __webpack_public_path__ + "img/andrew-gordon.4f0908e1.png";